export default __webpack_public_path__ + "static/media/arrow-down.69a0659a.svg";